import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { NewInvitationState } from './new-invitation.state';

export namespace NewInvitationSelectors {
  export const newInvitation = (state: AppState): NewInvitationState => state.newInvitation;

  export function getState(): MemoizedSelector<
    AppState,
    NewInvitationState,
    DefaultProjectorFn<NewInvitationState>
  > {
    return createSelector(newInvitation, (state: NewInvitationState) => state);
  }
}
